<template>
  <div class="home">
  </div>
</template>

<script>
export default {
  name: 'Home',
  created() {
  	let token=window.localStorage.getItem("token");
	console.log(token);
	if(token){
		
	}else{
		this.$router.push('/login');
	}
  }
}
</script>
